import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.css'],
})
export class PageContainerComponent {
  constructor() {}
}
